import { render } from "./PixelsToInches.vue?vue&type=template&id=5c10df02"
import script from "./PixelsToInches.vue?vue&type=script&lang=js"
export * from "./PixelsToInches.vue?vue&type=script&lang=js"

import "./PixelsToInches.vue?vue&type=style&index=0&id=5c10df02&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__